import {
  Box,
  Button,
  Container,
  Flex,
  Select,
  SimpleGrid,
  Title,
  createStyles,
  Indicator,
  Text,
  TextInput,
  Grid,
  Popover,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AccordionCheck from "../../../components/AccordionCheck";
import { editTask, getClientTask } from "../../../services/task";
import { decrypt } from "../../../utils";
import { useMediaQuery } from "@mantine/hooks";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import NewTaskModal from "../../../components/NewTaskModal";
import { CommentDrawer } from "./CommentDrawer";
import { useDisclosure } from "@mantine/hooks";
import { DateInput, TimeInput } from "@mantine/dates";
import { getAllStaff } from "../../../services/staff";
import { IconChevronDown } from "@tabler/icons-react";
import { getAllSignatures } from "../../../services/signature";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { isCommunityIntegration, levelOfNeedOptions } from "./AddTask";
import { taskAdlHiddenFields } from ".";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
    backgroundColor: "#F5F5F5",
  },
  container: {
    // borderRadius: "15px",
    margin: "10px 20px 0  8px",
  },
  mainContainer: {
    borderRadius: "15px",
    backgroundColor: "#ffffff",
    padding: "20px 10px 10px 20px",
    marginBottom: "20px",
  },
  topContainer: {
    borderRadius: "15px",
    backgroundColor: "#ffffff",
    padding: "10px 10px 15px 10px",
    marginBottom: "20px",
  },
  checkBoxParent: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    "@media (min-width:992px)": {
      padding: "0 140px",
    },
  },
  flex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "20px",
  },
  mainHeading: {
    margin: "0",
  },
  draft: {
    p: {
      margin: "0",
      border: "1px solid #fab005",
      padding: "2px 8px",
      borderRadius: "4px",
      color: "#fab005",
    },
  },
  completed: {
    p: {
      margin: "0",
      border: "1px solid green",
      padding: "2px 8px",
      borderRadius: "4px",
      color: "green",
    },
  },
  expired: {
    p: {
      margin: "0",
      border: "1px solid red",
      padding: "2px 8px",
      borderRadius: "4px",
      color: "red",
    },
  },
  detail: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  detail: {
    span: {
      color: "#A8A8A8",
    },
  },
  detail: {
    p: {
      margin: "0",
    },
  },
  info: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  info: {
    p: {
      margin: "0",
      textAlign: "center",
    },
  },
  btnFlex: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "20px 0",
    gap: "20px",
  },
  divGap: {
    margin: "20px 0",
    alignItems: "center",
  },
  commentBtnStyle: {
    boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#F4F3FF",
    color: "#6C63FF",
  },
  commentFlex: {
    "@media (max-width:600px)": {
      marginTop: "20px",
    },
  },
  signatureImg: {
    width: 250,
    height: "auto",
  },
  iconStyle: {
    width: "20px",
    height: "20px",
    color: "#94A3B8",
  },
  commentRequiredPopover: {
    padding: "8px 16px",
    backgroundColor: "#FDA29B",
    fontSize: 16,
    fontWeight: 500,
    color: "#000",
    fontFamily: "Inter",
  },
}));
const EditTask = () => {
  const { classes } = useStyles();
  const isMoobileScreen = useMediaQuery("(max-width: 600px)");
  const isTabletScreen = useMediaQuery("(max-width: 1030px)");
  const { tasks } = useSelector((state) => state?.task);
  const [opened, { open, close }] = useDisclosure(false);
  const [taskDateValue, setTaskDateValue] = useState();
  const { staff } = useSelector((state) => state?.staff);
  const { allPatients } = useSelector((state) => state?.patient);
  const { allFacilities } = useSelector((state) => state?.facility);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [notes, setNotes] = useState("");
  const [comments, setComments] = useState([]);
  const [checks, setChecks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState();
  const { allSignature } = useSelector((state) => state?.signature);
  const [activePlan, setActvePlan] = useState(null);

  const { profile } = useSelector((state) => state.profile);
  let userType = profile?.user?.type;
  let userRole = profile?.user?.role;

  const selectedStaffData = staff?.staffs?.find(
    (s) => s?.id === selectedStaff || s?._id === selectedStaff,
  );
  const taskStatus = state?.status;
  const [requiredCheckedFields, setRequiredCheckedFields] = useState([]);
  const [
    commentRequiredPopoverOpened,
    { open: commentRequiredPopoverOpen, close: commentRequiredPopoverClose },
  ] = useDisclosure(false);
  const { allPlans } = useSelector((state) => state?.supportPlan);

  useEffect(() => {
    getAllStaff("withAdmin");
    getAllSignatures();
  }, []);

  useEffect(() => {
    const initializeTask = async () => {
      let fieldIds = state?.fieldsDone?.map((item) => {
        return {
          field: item?.field?._id,
          textField: item?.textField,
          staff: item?.staff?.id,
          shift: item.shift,
          checkedAt: item?.checkedAt,
        };
      });

      setChecks(fieldIds);

      setSelectedStaff(state?.selectedShift?.staff?.id);
      setNotes(
        state?.notes?.find(
          (obj) =>
            obj?.staff?.id === state?.selectedShift?.staff?.id &&
            obj.shift === state?.selectedShift?.name,
        )?.note || "",
      );

      setComments(state?.comments);
      setHasEnded(taskStatus == "completed" ? true : false);

      const parsedDate = new Date(state?.dateTime);
      if (!isNaN(parsedDate)) {
        setTaskDateValue(parsedDate);
        form.setFieldValue("date", parsedDate);
      }
    };

    if (state) {
      initializeTask();
    }
  }, [state]);


  const form = useForm({
    initialValues: {
      client: state?.client ? state?.client?.id : "",
      facility: state?.facility ? state?.facility?.id : "",
      shift: state?.selectedShift?.name,
      startedBy: state?.selectedShift?.staff?.id,
      providerLicense: state?.providerLicense || "",
      placeOfService: state?.placeOfService || "",
      state: state?.state || "",
      zipcode: state?.zipcode || "",
      site: state?.site || "",
      levelofneed: state?.levelofneed || "",
      timeIn: state?.timeIn || "",
      timeOut: state?.timeOut || "",
    },
  });

  async function fetchActivePlan(facilityId) {
    if (state?.taskType?.name === "Activities of Daily Living") {
      // if (form?.values?.client) {
      let activePlan = allPlans?.find((v) => {
        const match = v?.client?._id === form.values?.client; // String comparison
        const facMatch = v?.facility?._id === facilityId; // String comparison
        return (
          match &&
          facMatch &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true &&
          v?.servicePlanData?.activitiesOfDailyLiving
        );
      })?.servicePlanData;
      setActvePlan(activePlan);
      return activePlan;
    } else {
      return null;
    }
  }

  const onSave = async (values) => {
    if (state?.taskType?.general !== true) {
      const invalidFields = [];
      state?.taskType.subTasks.forEach((subTask) => {
        subTask.fields.forEach((field) => {
          if (field.required) {
            const checkEntry = checks.find((c) => c.field === field._id);
            if (
              checkEntry &&
              (!checkEntry.textField || checkEntry.textField.trim() === "")
            ) {
              invalidFields.push(field);
            }
          }
        });
      });

      if (invalidFields.length > 0) {
        setRequiredCheckedFields(invalidFields);
        return;
      }
    }

    if (state?.taskType?.commentRequired && comments?.length === 0) {
      commentRequiredPopoverOpen();
      return;
    }
    setLoading(true);

    let formattedComments = comments?.map((_c) => {
      if (_c?.text) {
        return _c?.text;
      } else {
        return _c;
      }
    });

    let payload = {
      client: values?.client,
      facility: values?.facility,
      notes,
      comments: formattedComments,
      date: taskDateValue,
      fieldsDone: checks,
      taskId: state?.id,
      shift: state?.selectedShift?.name,
      startedBy: selectedStaff,
      staff: profile?.user?.id,
    };
    if (isIndividualizedSkillsType) {
      payload = {
        ...payload,
        providerLicense: values?.providerLicense,
        placeOfService: form?.values?.placeOfService || "",
        state: form?.values?.state || "",
        zipcode: form?.values?.zipcode || "",
        site: values?.site,
        levelofneed: values?.levelofneed,
        timeIn: values?.timeIn,
        timeOut: values?.timeOut,
      };
    }

    await editTask(payload, navigate, setLoading);
    setLoading(false);
  };

  const AuctionTimer = () => {
    const [remainingTime, setRemainingTime] = useState("");

    useEffect(() => {
      let interval;
      interval = setInterval(() => {
        // const now = moment();
        // const end = moment(state?.taskEndAt);
        const now = moment.tz(moment(), profile?.user?.timeZone);
        const end = moment.tz(
          moment(state?.taskEndAt),
          profile?.user?.timeZone,
        );

        const duration = moment.duration(end.diff(now));
        if (duration.asSeconds() <= 0) {
          clearInterval(interval);
          setRemainingTime("Task Ended!");
          setHasEnded(true);
        } else {
          const days = Math.floor(duration.asDays());
          const hours = String(duration.hours()).padStart(2, "0");
          const minutes = String(duration.minutes()).padStart(2, "0");
          const seconds = String(duration.seconds()).padStart(2, "0");
          setRemainingTime(
            days === 0
              ? `${hours}h ${minutes}m ${seconds}s`
              : `${days}d ${hours}h ${minutes}m ${seconds}s`,
          );
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }, [state?.taskEndAt]);

    return (
      <>
        <div style={{ minWidth: "130px" }}>
          <p
            style={{
              textTransform:
                remainingTime === "Task Ended!" ? "initial" : "lowercase",
              fontSize: remainingTime === "Task Ended!" ? "16px" : "18px",
            }}
          >
            {remainingTime || "-"}
          </p>
        </div>
      </>
    );
  };

  const isIndividualizedSkillsType =
    state?.taskType?.name === "Individualized Skills and Socialization Log";

  const activeStaffData =
    staff?.staffs
      ?.filter((_s) => _s.active === true && !_s.deleted)
      ?.map((_s) => ({
        value: _s.id,
        label: _s.name,
      })) || [];

  const filteredPatients =
    profile?.user?.id === selectedStaff
      ? allPatients
          ?.filter((p) => p?.active === true && p?.deleted === false)
          .map((data) => ({
            value: data?.id,
            label: data?.name,
          }))
      : allPatients
          ?.filter(
            (patient) =>
              patient?.active === true &&
              patient?.deleted === false &&
              Array.isArray(patient?.staff) &&
              patient.staff.some(
                (staff) =>
                  staff.staffId === selectedStaff && staff.isAssign === true,
              ),
          )
          .map((p) => ({
            value: p.id,
            label: p.name,
          }));

  const staffSignature = allSignature?.find(
    ({ staff, admin }) =>
      (staff && staff === selectedStaff) || (admin && admin === selectedStaff),
  );
  const handleTimeChange = (field, value) => {
    form.setFieldValue(field, value);
  };

  useEffect(() => {
    const initializeActivePlan = async () => {
      if (state?.facility?.id) {
        await fetchActivePlan(state.facility.id);
      }
    };

    initializeActivePlan();
  }, [state?.facility?.id]);


  // useEffect(() => {
  //   if (form.values.client && allPatients?.length) {
  //     const selectedClient = allPatients.find(
  //       (p) => p?.id === form.values.client
  //     );

  //     const clientLevel = selectedClient?.form1?.levelofneed || "";

  //     form.setFieldValue("levelofneed", clientLevel);
  //   } else {
  //     form.setFieldValue("levelofneed", "");
  //   }
  // }, [form.values.client, allPatients]);

  return (
    <Container fluid className={classes.content} p={0}>
      <AppNavbar title={"Task"} profile={profile} />
      <Flex
        align="center"
        gap={5}
        mt={5}
        onClick={() =>
          state?.isClientPage === true
            ? navigate(-1) // go back
            : navigate("/home/tasks")
        }
        style={{ cursor: "pointer", width: "fit-content" }}
      >
        <MdKeyboardArrowLeft size={30} />
        <Text fw={400} fz={14} c={"#262626"} ff={"Inter"}>
          Back
        </Text>
      </Flex>
      <Title order={3} mt={5} ml={10}>
        Edit Task
      </Title>
      <Box className={classes.container}>
        <form onSubmit={form?.onSubmit((values) => onSave(values))}>
          <Box className={classes.topContainer}>
            <div className={classes.flex}>
              <Flex align="center" gap={50}>
                <h2 className={classes.mainHeading}>
                  {state?.taskType?.name || ""}
                </h2>
                {state?.status === "draft" && !hasEnded && (
                  <div className={classes.draft}>
                    <p>Draft</p>
                  </div>
                )}
                {hasEnded && (
                  <div className={classes.completed}>
                    <p>Completed</p>
                  </div>
                )}
                {state?.status === "expired" && (
                  <div className={classes.expired}>
                    <p>Expired</p>
                  </div>
                )}
                {!isIndividualizedSkillsType && (
                  <DateInput
                    value={taskDateValue}
                    onChange={(date) => {
                      setTaskDateValue(date);
                    }}
                    label="Date"
                    placeholder="Select Date"
                    radius="md"
                    maxDate={new Date()}
                    // disabled={taskStatus === "draft" ? true : false}
                  />
                )}
                {staffSignature?.signature || staffSignature?.signatureImage ? (
                  <Flex justify="flex-end">
                    <img
                      src={
                        decrypt(staffSignature?.signature) ||
                        decrypt(staffSignature?.signatureImage)
                      }
                      alt="signature"
                      className={classes.signatureImg}
                    />
                  </Flex>
                ) : staffSignature?.signatureText ? (
                  <Text fz={32} fw={400} ff="Island Moments" color="#171717">
                    {staffSignature?.signatureText}
                  </Text>
                ) : null}
              </Flex>
              <Box>
                <NewTaskModal
                  state={state}
                  tasks={tasks}
                  className={classes.taskBtn}
                />
              </Box>
            </div>
            <SimpleGrid
              cols={isMoobileScreen ? 1 : isTabletScreen ? 3 : 4}
              className={classes.divGap}
            >
              <div className={classes.detail}>
                <Select
                  data={activeStaffData}
                  value={form.values.startedBy}
                  label="Select Staff"
                  disabled={userType === "staff" && userRole === "staff" ? true : false}
                  onChange={(e) => {
                    setSelectedStaff(e);
                    form.setFieldValue("startedBy", e);
                    form.setFieldValue("client", "");
                    form.setFieldValue("facility", "");
                  }}
                  rightSection={
                    <IconChevronDown className={classes.iconStyle} />
                  }
                  // placeholder={state?.selectedShift?.staff?.name}
                  radius={"md"}
                />
                {/* <Select
                  label="Staff Name"
                  disabled={true}
                  data={[]}
                  radius={"md"}
                /> */}
              </div>
              <div className={classes.info}>
                <Select
                  label="Client Name"
                  value={form.values.client}
                  // value={state?.client?.id}
                  placeholder={"Select Client"}
                  // placeholder={
                  //   state?.client
                  //     ? decrypt(state?.client?.name, false)
                  //     : "Client"
                  // }
                  radius={"md"}
                  disabled={
                    userType === "staff"
                      ? true
                      : state?.isClientPage
                        ? true
                        : false
                  }
                  rightSection={
                    <IconChevronDown className={classes.iconStyle} />
                  }
                  onChange={async (value) => {
                    form.setFieldValue("client", value);
                    const selectedClient = allPatients.find(
                      (p) => p?.id === value,
                    );

                    const clientLevel =
                      selectedClient?.form1?.levelofneed?.replace(/–/g, "-") ||
                      "";
                    if (clientLevel) {
                      form.setFieldValue("levelofneed", clientLevel);
                    } else {
                      form.setFieldValue("levelofneed", "");
                    }
                    // let facility = allPatients?.find(
                    //   (item) => item.id === value
                    // )?.facilityId?.id;
                    // form.setFieldValue("facility", facility);
                  }}
                  data={filteredPatients || []}
                  // data={
                  //   allPatients
                  //     ?.filter(
                  //       (patient) =>
                  //         patient?.active === true &&
                  //         patient?.deleted === false &&
                  //         Array.isArray(patient?.staff) &&
                  //         patient.staff.some(
                  //           (staff) =>
                  //             staff.staffId === selectedStaff &&
                  //             staff.isAssign === true
                  //         )
                  //     )
                  //     .map((p) => ({
                  //       value: p.id,
                  //       label: p.name,
                  //     })) || []
                  // }
                />
              </div>
              <div className={classes.info}>
                <Select
                  label="Facitlity"
                  placeholder={"Select facility"}
                  // placeholder={
                  //   state?.client ? state?.facility?.name : "Facility"
                  // }
                  disabled={userType === "staff" ? true : false}
                  // data={[]}
                  rightSection={
                    <IconChevronDown className={classes.iconStyle} />
                  }
                  radius={"md"}
                  {...form.getInputProps("facility")}
                  value={form.values.facility}
                  onChange={async (id) => {
                    form.setFieldValue("facility", id);
                    const facilityDetails = allFacilities?.facilities?.find(
                      (f) => f?.id === id,
                    );
                    if (isIndividualizedSkillsType) {
                      form.setFieldValue(
                        "placeOfService",
                        facilityDetails?.address || "",
                      );
                      form.setFieldValue("state", facilityDetails?.state || "");
                      form.setFieldValue(
                        "zipcode",
                        facilityDetails?.zipcode || "",
                      );
                      form.setFieldValue(
                        "providerLicense",
                        facilityDetails?.providerLicense || "",
                      );
                    }
                    await fetchActivePlan(id);
                    await getClientTask({
                      client: form.values?.client,
                      type:
                        // _ap?.activePlanArray[0]?.activitiesOfDailyLiving
                        //   ?.fieldsDone
                        //   ? ADL_ACTIVE_PLAN_TASK_TYPE_ID
                        //   :
                        state?.taskType?.id,
                    });
                    if (id === state?.facility?.id) {
                      // Restore original checks when switching back to the original client
                      const originalChecks = state?.fieldsDone?.map((item) => ({
                        field: item?.field?._id,
                        textField: item?.textField,
                        staff: item?.staff?.id,
                        shift: item.shift,
                        checkedAt: item?.checkedAt,
                      }));
                      setChecks(originalChecks || []);
                    } else {
                      setChecks([]);
                    }

                    //  setClientValue(data);
                  }}
                  // value={state?.facility?.id}
                  data={
                    allFacilities?.facilities?.map((data) => {
                      let filteredPatient = allPatients?.find(
                        (item) =>
                          item.id == form.getTransformedValues()?.client,
                      );
                      let facilityDisabled = filteredPatient?.facilityId?.find(
                        (_f) => _f?.id == data?.id,
                      )
                        ? false
                        : true;
                      return {
                        value: data?.id,
                        label: data?.name,
                        disabled: facilityDisabled,
                      };
                    }) || []
                  }
                />
              </div>
              {isIndividualizedSkillsType ? (
                <div className={classes.detail}>
                  <TextInput
                    label="License Number"
                    radius="md"
                    // readOnly
                    placeholder="Add License Number"
                    value={form.values.providerLicense || ""}
                    {...form.getInputProps("providerLicense")} // License Number is same as Provider License
                  />
                </div>
              ) : (
                <div className={classes.info}>
                  <Select
                    label="Shift"
                    radius={"md"}
                    value={form.values.shift}
                    disabled={userType === "staff" ? true : false}
                    placeholder={state?.selectedShift?.name}
                    data={["Morning", "Evening", "Night"]}
                    rightSection={<IconChevronDown size={16} />}
                  />
                </div>
              )}
            </SimpleGrid>
            {isIndividualizedSkillsType && (
              <>
                <Grid>
                  <Grid.Col
                    span={isMoobileScreen ? 12 : isTabletScreen ? 6 : 6}
                  >
                    <TextInput
                      label="Place of Service"
                      value={form?.values?.placeOfService || ""}
                      radius="md"
                      {...form.getInputProps("placeOfService")}
                    />
                  </Grid.Col>

                  <Grid.Col
                    span={isMoobileScreen ? 12 : isTabletScreen ? 6 : 3}
                  >
                    <TextInput
                      label="State"
                      value={form?.values?.state || ""}
                      radius="md"
                      variant="default"
                      {...form.getInputProps("state")}
                    />
                  </Grid.Col>

                  {/* Zip Code - 25% width */}
                  <Grid.Col
                    span={isMoobileScreen ? 12 : isTabletScreen ? 6 : 3}
                  >
                    <TextInput
                      label="Zip Code"
                      value={form?.values?.zipcode || ""}
                      radius="md"
                      {...form.getInputProps("zipcode")}
                    />
                  </Grid.Col>
                </Grid>
                <SimpleGrid
                  cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 4}
                  mt={10}
                >
                  <div className={classes.detail}>
                    <Select
                      id="add-task-staff"
                      label="Site"
                      radius={"md"}
                      placeholder={"Select Site"}
                      rightSectionPointerEvents="none"
                      rightSection={
                        <IconChevronDown className={classes.iconStyle} />
                      }
                      value={form.values.site || ""}
                      data={["On-Site", "Off-Site"]}
                      {...form.getInputProps("site")}
                    />
                  </div>
                  <div className={classes.detail}>
                    <DateInput
                      value={taskDateValue}
                      onChange={setTaskDateValue}
                      label="Date"
                      placeholder="Select Date"
                      radius={"md"}
                      {...form.getInputProps("date")}
                      maxDate={new Date()}
                    />
                  </div>
                  <div className={classes.info}>
                    {state?.shift?.find(
                      (item) => item?.staff?.id === profile?.user?.id,
                    ) ? (
                      <Select
                        radius={"md"}
                        label="Shift"
                        rightSectionPointerEvents="none"
                        rightSection={
                          <IconChevronDown className={classes.iconStyle} />
                        }
                        placeholder={
                          state?.shift?.find(
                            (item) => item?.staff?.id === profile?.user?.id,
                          )?.name
                        }
                        // disabled={true}
                        value={
                          state?.shift?.find(
                            (item) => item?.staff?.id === profile?.user?.id,
                          )?.name
                        }
                        data={["Morning", "Evening", "Night"]}
                        {...form.getInputProps("shift")}
                      />
                    ) : (
                      <Select
                        id="add-task-staff"
                        label="Shift"
                        radius={"md"}
                        placeholder={"Select an option"}
                        rightSectionPointerEvents="none"
                        rightSection={
                          <IconChevronDown className={classes.iconStyle} />
                        }
                        data={["Morning", "Evening", "Night"]}
                        {...form.getInputProps("shift")}
                      />
                    )}
                  </div>
                  <div className={classes.info}>
                    <Select
                      id="level-of-care"
                      searchable
                      label="Level of Need"
                      data={levelOfNeedOptions}
                      radius={"md"}
                      value={form.values.levelofneed || ""}
                      placeholder="Select Level of Need"
                      // readOnly
                      {...form.getInputProps("levelofneed")}
                      rightSection={
                        <IconChevronDown className={classes.iconStyle} />
                      }
                    />
                  </div>
                </SimpleGrid>
                <SimpleGrid
                  cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 4}
                  mt={10}
                >
                  <TimeInput
                    label="Time In"
                    format="12"
                    // className={classes.datePicker}
                    icon={
                      <img
                        style={{ width: "20px" }}
                        src={"/assets/images/clock.png"}
                        alt="Icon"
                      />
                    }
                    radius={"md"}
                    value={form.values.timeIn || ""}
                    onChange={(e) => {
                      const isSafari = /^((?!chrome|android).)*safari/i.test(
                        navigator.userAgent,
                      );
                      let time = e.target.value
                        .split(":")
                        ?.slice(0, 2)
                        ?.join(":");

                      isSafari
                        ? handleTimeChange("timeIn", time)
                        : handleTimeChange("timeIn", time);
                    }}
                  />
                  <TimeInput
                    label="Time Out"
                    format="12"
                    // className={classes.datePicker}
                    icon={
                      <img
                        style={{ width: "20px" }}
                        src={"/assets/images/clock.png"}
                        alt="Icon"
                      />
                    }
                    radius={"md"}
                    value={form.values.timeOut || ""}
                    onChange={(e) => {
                      const isSafari = /^((?!chrome|android).)*safari/i.test(
                        navigator.userAgent,
                      );
                      let time = e.target.value
                        .split(":")
                        ?.slice(0, 2)
                        ?.join(":");

                      isSafari
                        ? handleTimeChange("timeOut", time)
                        : handleTimeChange("timeOut", time);
                    }}
                  />
                </SimpleGrid>
              </>
            )}
            {/* <div className={classes.detail}>
                <p>
                  <strong>Date Created: </strong>{" "}
                  {state?.dateTime &&
                    moment(
                      state?.dateTime ? state?.dateTime : state?.createdAt
                    ).format("MM-DD-YYYY")}{" "}
                  at{" "}
                  {state?.dateTime
                    ? moment(state?.dateTime).format("hh:mm a")
                    : "-"}
                </p>
              </div> */}
           {profile?.user?.role !== "staff" && <Box mt={10} className={classes.detail}>
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <strong>Time Remaining: </strong>{" "}
                {state?.dateTime &&
                state?.taskEndAt &&
                state?.status !== "completed" ? (
                  <AuctionTimer />
                ) : (
                  "Task Ended!"
                )}
              </p>
            </Box>}
          </Box>

          <div>
            <h3>Task List</h3>
          </div>

          <Box className={classes.mainContainer}>
            <Box
              className={`${classes.mainContainer} ${classes.checkBoxParent}`}
            >
              <SimpleGrid cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 4}>
                {state?.taskType?.subTasks
                  ?.filter((task) => {
                    if (task?.task?.name === isCommunityIntegration) {
                      return form.values.site === "Off-Site";
                    }
                     if (task?.task?.name === "Body Care" && activePlan)
                          return false;

                    if (
                      state?.taskType?.name === "Activities of Daily Living" &&
                      !activePlan &&
                      (task?.task?.name === "Hygiene" ||
                        task?.task?.name === "Nutrition and Hydration")
                    ) {
                      return false;
                    }

                    // If activePlan has fieldsDone, only show subtasks that have matching fields
                    // if (
                    //   activePlan?.activitiesOfDailyLiving?.fieldsDone?.length >
                    //   0
                    // ) {
                    //   // const planFieldIds =
                    //   //   activePlan?.activitiesOfDailyLiving.fieldsDone.map(
                    //   //     (fd) => fd.field,
                    //   //   );

                    //   const planFieldIds =
                    //     activePlan?.activitiesOfDailyLiving?.fieldsDone.map(
                    //       (fd) => fd.field,
                    //     );

                    //   // Check if any field in this subtask matches the plan's fields
                    //   const hasMatchingField = task?.fields?.some((field) =>
                    //     planFieldIds.includes(field._id),
                    //   );

                    //   return hasMatchingField;
                    // }
                    return true;
                  })
                  .map((tasks) => {
                    const subTaskName = tasks?.task?.name;

                    const shouldHideFields =
                      state?.taskType?.name === "Activities of Daily Living" &&
                      !activePlan;

                      let filteredFields = shouldHideFields
                        ? tasks?.fields?.filter(
                            (field) =>
                              !taskAdlHiddenFields[subTaskName]?.includes(
                                field?.name,
                              ),
                          ) || []
                        : tasks?.fields || [];

                    // let filteredFields = null;

                    // if (
                    //   activePlan?.activitiesOfDailyLiving?.fieldsDone?.length >
                    //   0
                    // ) {
                    //   const planFieldIds =
                    //     activePlan?.activitiesOfDailyLiving?.fieldsDone?.map(
                    //       (fd) => String(fd.field),
                    //     ) || [];

                    //   // Filter fields: only include fields that exist in planFieldIds
                    //   filteredFields = (tasks?.fields || []).filter((field) =>
                    //     planFieldIds.includes(String(field._id)),
                    //   );

                    //   if (shouldHideFields) {
                    //     filteredFields = filteredFields.filter(
                    //       (field) =>
                    //         !taskAdlHiddenFields[subTaskName]?.includes(
                    //           field?.name,
                    //         ),
                    //     );
                    //   }
                    // } else {
                    //   filteredFields = shouldHideFields
                    //     ? tasks?.fields?.filter(
                    //         (field) =>
                    //           !taskAdlHiddenFields[subTaskName]?.includes(
                    //             field?.name,
                    //           ),
                    //       ) || []
                    //     : tasks?.fields || [];
                    // }

                    // let filteredFields = shouldHideFields
                    //   ? tasks?.fields?.filter(
                    //       (field) =>
                    //         !taskAdlHiddenFields[subTaskName]?.includes(
                    //           field?.name,
                    //         ),
                    //     ) || []
                    //   : tasks?.fields || [];

                    // if (activePlan?.activitiesOfDailyLiving?.fieldsDone
                    //         ?.length  > 0) {
                    //   const planFieldIds =
                    //     state.fieldsDone?.map((fd) => String(fd.field._id)) ||
                    //     [];

                    //   filteredFields = (tasks?.fields || []).filter((field) =>
                    //     planFieldIds.includes(String(field._id)),
                    //   );
                    // }


                    return (
                      <div>
                        <AccordionCheck
                          type={"edit"}
                          Data={filteredFields}
                          checksDone={state?.fieldsDone || []}
                          Heading={tasks?.task?.name}
                          setChecks={setChecks}
                          checks={checks}
                          userType={userType}
                          userId={profile?.user?.id}
                          shift={state?.selectedShift?.name}
                          selectedStaff={selectedStaff}
                          profile={profile}
                          selectedStaffData={selectedStaffData}
                          requiredCheckedFields={requiredCheckedFields}
                        />
                      </div>
                    );
                  })}
              </SimpleGrid>
            </Box>
            <div>
              {/* {!hasEnded && ( */}
              <div className={classes.btnFlex}>
                <Button
                  w={200}
                  size="lg"
                  color="gray"
                  radius={"md"}
                  variant="outline"
                  onClick={() => {
                    navigate("/home/tasks");
                  }}
                >
                  Cancel
                </Button>
                <Button
                  id="update-task"
                  w={200}
                  size="lg"
                  c={"#000"}
                  type="submit"
                  radius={"md"}
                  color="yellow"
                  loading={loading}
                >
                  Update
                </Button>
              </div>
              {/* )} */}
            </div>
            <Flex className={classes.commentFlex} justify="flex-end">
              <Popover
                position="top"
                shadow="md"
                opened={commentRequiredPopoverOpened}
                withArrow
                classNames={{
                  dropdown: classes.commentRequiredPopover,
                }}
              >
                <Popover.Target>
                  <Indicator label={comments?.length} color="red" size={20}>
                    <Button
                      w={200}
                      size="lg"
                      radius={"md"}
                      onClick={open}
                      variant="light"
                      className={classes.commentBtnStyle}
                    >
                      + Comments
                    </Button>
                  </Indicator>
                </Popover.Target>
                <Popover.Dropdown>Required</Popover.Dropdown>
              </Popover>
            </Flex>
          </Box>
          <CommentDrawer
            title={"Comments"}
            opened={opened}
            close={close}
            comments={comments}
            setComments={setComments}
            data={
              selectedStaffData
                ? selectedStaffData
                : state?.selectedShift?.staff
            }
            taskTypeDetails={state?.taskType}
            commentRequiredPopoverClose={commentRequiredPopoverClose}
          />
        </form>
      </Box>
    </Container>
  );
};

export default EditTask;
